import React from 'react';
import { useSelector } from 'react-redux';
import { NextPage, NextPageContext } from 'next';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { addressCard, addressCardProps } from '~/src/constants/addressCard';
import { addressList, addressListProps } from '~/src/constants/addressList';
import Layout from '~/src/features/_layout';
import AddressLayout from '~/src/features/address-layout';
import { initialProps } from '~/src/helpers/basePageFunc';
import { selectCompanyName } from '~/src/store/selectors/city';

interface AddressPageProps  {
    currentCity: ICurrentCity,
    district: addressListProps[],
    cards: addressCardProps[],
    domains: string[],
}

const AddressPage: NextPage<AddressPageProps> = ({ currentCity, district, cards, domains }) => {
    const companyName = useSelector(selectCompanyName);

    return (
        <Layout
            title={`Интернет провайдеры по адресу дома | Проверить адрес подключения
                интернета от ${companyName} в ${currentCity.cityIn}`}
            description={`Проверьте возможность подключения интернета и цифрового ТВ от ${companyName}
                по адресу вашего дома. Оставьте заявку на подключение: ☎️ ${currentCity.phone}`}
            withMenu={true}
            withFooter={true}
            withChat={true}
        >
            {domains.includes(currentCity.domain)
                ? <AddressLayout districts={district[0].districts} cards={cards}/>
                : null
            }
        </Layout>
    );
};

AddressPage.getInitialProps = async(options: NextPageContext) => {
    await initialProps(options);
    const { store } = options;
    const { city: { currentCity } } = store.getState();
    const district = addressList.filter(item => item.domain === currentCity.domain);
    const domains = addressList.map(item => item.domain);
    const cards = addressCard;

    return { currentCity, district, cards, domains };
};

export default AddressPage;
